export const kCO2e = 'kgCO₂e'
export const tCO2e = 'tCO₂e'
export const CO2e = 'CO₂e'
export const gCO2e = 'gCO₂e'

export const co2 = 'CO₂'
export const ch4 = 'CH₄'
export const n2o = 'N₂O'
export const hfcs = 'HFCs'
export const pfcs = 'PFCs'
export const sf6 = 'SF₆'
export const nf3 = 'NF₃'
